import {ChangeDetectorRef, Component, OnDestroy, OnInit} from "@angular/core";
import {ScreenLayoutEditorModel} from "../screen-layout-editor.model";
import {TouchItemData} from "../../../screen-layout.data";
import {Subscription} from "rxjs";

@Component({
    selector: "wbo-screen-layout-sub-menu-header",
    templateUrl: "./screen-layout-sub-menu-header.component.html",
    styleUrls: ["./screen-layout-sub-menu-header.component.scss"]
})
export class ScreenLayoutSubMenuHeaderComponent implements OnInit, OnDestroy {

    selectedSubMenus: TouchItemData[];

    page: TouchItemData[];

    subscriptions: Subscription = new Subscription();

    skip: number = 0;

    constructor(public model: ScreenLayoutEditorModel, private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        this.subscriptions.add(this.model.selectedSubMenus$.subscribe(data => {
            this.selectedSubMenus = data;
            this.updatePage(true);
            this.changeDetectorRef.detectChanges();
        }));

        this.subscriptions.add(this.model.numOfColumns$.subscribe(() => {
            if (this.selectedSubMenus) {
                this.updatePage(true);
                this.changeDetectorRef.detectChanges();
            }
        }));
    }

    updatePage(modelChanged: boolean): void {
        const page: TouchItemData[] = [];

        if (modelChanged || this.skip >= this.selectedSubMenus.length) {
            this.skip = this.selectedSubMenus.length - this.model.numOfColumns + 1;
            if (this.skip < 0) {
                this.skip = 0;
            }
        }

        let numberToShow: number = this.model.numOfColumns - 1;
        if (this.hasNext) {
            numberToShow--;
        }

        for (let i = 0; i < numberToShow; i++) {
            // reduce the number of columns to 2 to include the home item or previous page plus the next page
            const item: TouchItemData = this.selectedSubMenus[i + this.skip];
            if (item) {
                page.push(item);
            }
        }
        this.page = page;
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    get hasPrev(): boolean {
        return this.skip > 0;
    }

    get hasNext(): boolean {
        return this.selectedSubMenus.length - this.skip >= this.model.numOfColumns;
    }

    prevPage(): void {
        this.skip--;
        this.updatePage(false);
    }

    nextPage(): void {
        this.skip++;
        this.updatePage(false);
    }
}
